module.exports = __webpack_public_path__ + "media/images/app/products/index/styles/earrings/diamond-74dbe71cfa47f2747223bec7c22ae4e7.webp";